import type { AdminAgentRequestAttempt, AdminAgentResumeAttempt } from "../models/admin-agent.models";
import { ADMIN_AGENT_PANEL_DEFAULT_WIDTH, ADMIN_AGENT_PANEL_WIDTH_STORAGE_KEY } from "../utils/admin-agent.constants";
import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

// Keep panel preferences and unsent drafts through admin navigation and panel closing.
// None of these atoms persist conversations or overwrite the shared backend history.
export const adminAgentPanelOpenAtom = atom(false);
// Width is a per-browser preference; accessible conversations still live only in backend memory.
export const adminAgentPanelWidthAtom = atomWithStorage<number>(
  ADMIN_AGENT_PANEL_WIDTH_STORAGE_KEY,
  ADMIN_AGENT_PANEL_DEFAULT_WIDTH,
  undefined,
  { getOnInit: true },
);
export const adminAgentSelectedConversationAtom = atom<string | undefined>(undefined);
export const adminAgentDraftsAtom = atom<Record<string, string>>({});
export const adminAgentSendAttemptsAtom = atom<Record<string, AdminAgentRequestAttempt>>({});
export const adminAgentResumeAttemptsAtom = atom<Record<string, AdminAgentResumeAttempt>>({});
